import gql from 'graphql-tag';
import graphqlClient from '../helpers/graphqlClient';

export default new (class {
	async getLogo(pageName, facility) {
		const { data } = await graphqlClient.query({
			query: gql`
                {
                    cmsSponsorLogosLocalLogoModules(where: "SponsorLogo.isActive=true && LocalLogoModule.name=\\"${pageName}\\" &&  SponsorLogo.isLocalSponsor = true && SponsorLogo.facility_ID=${facility}") {
                        sponsorLogo {
                            logoBase64
                        }
                    }
                }
            `,

			fetchPolicy: 'no-cache'
		});
		if (data && data.cmsSponsorLogosLocalLogoModules.length) {
			return data.cmsSponsorLogosLocalLogoModules[0].sponsorLogo.logoBase64;
		} else {
			return null;
		}
	}
})();
